var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 102",
    style: {
      enableBackground: "new 0 0 104 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill:none;}\n\t.st2{fill:#1ABCFE;}\n\t.st3{fill:#0ACF83;}\n\t.st4{fill:#FF7262;}\n\t.st5{fill:#F24E1E;}\n\t.st6{fill:#A259FF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.95,37.83v18.78l2.41,0.01v-8.94h5.83v-2.37h-5.83V40.2h7.59v-2.37H29.95z M44.31,41.64c0.87,0,1.57-0.71,1.57-1.57 c0-0.87-0.71-1.57-1.57-1.57c-0.87,0-1.57,0.71-1.57,1.57C42.73,40.93,43.44,41.64,44.31,41.64z M43.08,44.01v12.61h2.41V44.01 H43.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.46,43.64c-3.21,0-5.45,2.72-5.45,5.94c0,3.22,2.24,5.94,5.45,5.94c1.47,0,2.68-0.57,3.56-1.49v1.67 c0,2.09-1.64,3.83-3.78,3.83c-0.77,0-1.54-0.29-2.15-0.72l-1.22,2.1c0.97,0.63,2.12,0.99,3.35,0.99c3.43,0,6.2-2.77,6.2-6.2V44.01 h-2.4v1.12C57.14,44.21,55.93,43.64,54.46,43.64z M51.43,49.58c0-2,1.53-3.57,3.3-3.57c1.77,0,3.3,1.57,3.3,3.57 s-1.53,3.57-3.3,3.57C52.96,53.15,51.43,51.58,51.43,49.58L51.43,49.58z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.14,46.01c-1.43,0-2.59,1.22-2.59,2.64v7.96h-2.41V44.01h2.41v1.15c0.71-0.91,1.75-1.52,3.11-1.52 c1.69,0,2.99,0.84,3.75,2.13c0.84-1.24,2.2-2.13,3.85-2.13c2.75,0,4.47,2.22,4.47,4.96v8.01h-2.41v-7.97c0-1.43-1.16-2.64-2.59-2.64 c-1.43,0-2.59,1.22-2.59,2.64v7.97h-2.41v-7.97C71.73,47.21,70.57,46.01,69.14,46.01z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.61,45.44c-1.08-1.11-2.55-1.8-4.25-1.8c-3.59,0-6.15,3.05-6.15,6.68c0,3.63,2.55,6.68,6.15,6.68 c1.7,0,3.18-0.69,4.25-1.8v1.42h2.41V44.01h-2.41V45.44z M86.63,50.32c0-2.4,1.84-4.31,4-4.31c2.15,0,4,1.9,4,4.31 c0,2.4-1.84,4.31-4,4.31C88.47,54.62,86.63,52.72,86.63,50.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.57,37.83h16.23v24.34H8.57V37.83z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.69,50c0-2.24,1.81-4.06,4.06-4.06c2.24,0,4.06,1.81,4.06,4.06c0,2.24-1.81,4.06-4.06,4.06 C18.51,54.07,16.69,52.24,16.69,50L16.69,50z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.57,58.12c0-2.24,1.81-4.06,4.06-4.06h4.06v4.06c0,2.24-1.81,4.06-4.06,4.06S8.57,60.36,8.57,58.12 L8.57,58.12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.69,37.83v8.11h4.06c2.24,0,4.06-1.81,4.06-4.06c0-2.24-1.81-4.06-4.06-4.06L16.69,37.83L16.69,37.83z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.57,41.89c0,2.24,1.81,4.06,4.06,4.06h4.06v-8.12h-4.06C10.39,37.83,8.57,39.65,8.57,41.89z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M8.57,50c0,2.24,1.81,4.06,4.06,4.06h4.06v-8.12h-4.06C10.39,45.94,8.57,47.77,8.57,50z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma1);
export default __webpack_public_path__ + "static/media/figma1.bce223cb40a38c415c22cc854cfb5bc9.svg";
export { ForwardRef as ReactComponent };